var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"disclaimer"},[_c('div',{staticClass:"disclaimer__text"},[_vm._t("default")],2),_c('social-networks',{staticClass:"disclaimer__social"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }